(() => {
  class CavCollectionEnquiry extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-enquiry-open]');
      this.form = this.querySelector('form');
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('[data-enquiry-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), a[href], [tabindex="0"]')].filter((element) => element.getClientRects().length);
        const first = focusable[0];
        const last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow;
        this.trigger.focus({ preventScroll: true });
      });
      this.form.addEventListener('invalid', (event) => {
        const field = event.target;
        field.setAttribute('aria-invalid', 'true');
        const error = this.querySelector(`#${field.id}-error`);
        if (error) error.hidden = false;
      }, true);
      this.form.addEventListener('input', (event) => {
        const field = event.target;
        if (!field.validity || !field.validity.valid) return;
        field.removeAttribute('aria-invalid');
        const error = this.querySelector(`#${field.id}-error`);
        if (error) error.hidden = true;
      });
      this.form.addEventListener('submit', (event) => {
        if (this.form.dataset.submitting === 'true') {
          event.preventDefault();
          return;
        }
        this.form.dataset.submitting = 'true';
        this.form.setAttribute('aria-busy', 'true');
        const button = this.querySelector('[data-enquiry-submit]');
        button.disabled = true;
        button.textContent = button.dataset.sending;
      });
      if (this.querySelector('[data-enquiry-result]')) this.open();
    }
    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      (this.querySelector('[data-enquiry-result]') || this.form.querySelector('input[required]'))?.focus();
    }
  }
  if (!customElements.get('cav-collection-enquiry')) customElements.define('cav-collection-enquiry', CavCollectionEnquiry);
})();
